import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import * as config from "@/config";
import axios from "@/plugins/axios";

Vue.use(Vuex)

const EXPORT_POLL_INITIAL_DELAY = 2000;
const EXPORT_POLL_BASE_INTERVAL = 3000;
const EXPORT_POLL_MAX_INTERVAL = 20000;
let workflowRuntimeRequest = null;
let workflowRuntimeRequestUserId = null;

function unwrapApiData(resp, fallbackMessage = 'Lỗi xử lý dữ liệu') {
	const payload = resp && resp.data !== undefined ? resp.data : resp;
	if (payload && payload.error) {
		const error = new Error(payload.error.message || fallbackMessage);
		error.payload = payload.error;
		throw error;
	}
	return payload && payload.data !== undefined ? payload.data : payload;
}

export default new Vuex.Store({
	state () {
		return {
			layout: 'default',
			profile: null,
			currentPermissions: [],
			token: localStorage.getItem('token'),
			userId: localStorage.getItem('userId'),
			loadingOverlay: false,
			prefectures: null,
			dataChart: {},
			mapInit: false,
			previewUpdateTime: '',
			productionUpdateTime: '',
			isResponseError: false,
			unreadNotification: 0,
			provinces: [],
			apartments: [],
			dictionaries: [],
			appraiseOther: [],
			mapLocation: config.map_location,
			mapFilter: [],
			navExp: true,
			exportJobs: [],
			exportJobTimers: {},
			workflowRuntime: {
				userId: null,
				workflows: [],
				loaded: false,
				loading: false,
				error: null
			},
		review: {
			myReviews: [],
			currentReview: null,
			reviewMeta: null,
			loading: false,
			error: null,
		},
		}
	},
	getters: {
		apartments: state => state.apartments,
		profile: state => state.profile,
		provinces: state => state.provinces,
		dictionaries: state => state.dictionaries,
		appraiseOther: state => state.appraiseOther,
		hasToken: state => state.token,
		userId: state => state.userId,
		layout: state => state.layout || 'default',
		prefectures: state => state.prefectures,
		dataChart: state => state.dataChart,
		currentPermissions: state => state.currentPermissions,
		mapInit: state => state.mapInit,
		previewUpdateTime: state => state.previewUpdateTime,
		productionUpdateTime: state => state.productionUpdateTime,
		isResponseError: state => state.isResponseError,
		unreadNotification: state => state.unreadNotification,
		mapLocation: state => state.mapLocation,
		mapFilter: state => state.mapFilter,
		navExp: state => state.navExp,
		exportJobs: state => state.exportJobs,
		activeExportJobs: state => state.exportJobs.filter(job => job.status !== 'completed' && job.status !== 'failed'),
		completedExportJobs: state => state.exportJobs.filter(job => job.status === 'completed'),
		workflowRuntime: state => state.workflowRuntime,
		workflowRuntimeWorkflows: state => state.workflowRuntime.workflows || [],
		workflowRuntimeActiveWorkflows: state =>
			(state.workflowRuntime.workflows || []).filter(
				workflow => !workflow.workflow_status || workflow.workflow_status === 'active'
			),
		myReviews: state => state.review.myReviews,
		currentReview: state => state.review.currentReview,
		reviewMeta: state => state.review.reviewMeta,
		reviewLoading: state => state.review.loading,
		reviewError: state => state.review.error,
	},
	mutations: {
		ADD_EXPORT_JOB (state, job) {
			const existingIndex = state.exportJobs.findIndex(item => item.jobId === job.jobId);
			if (existingIndex >= 0) {
				Vue.set(state.exportJobs, existingIndex, { ...state.exportJobs[existingIndex], ...job });
			} else {
				state.exportJobs.unshift(job);
			}
		},
		UPDATE_EXPORT_JOB (state, { jobId, patch }) {
			const idx = state.exportJobs.findIndex(job => job.jobId === jobId);
			if (idx >= 0) {
				const updated = { ...state.exportJobs[idx], ...patch };
				Vue.set(state.exportJobs, idx, updated);
			}
		},
		INCREMENT_EXPORT_JOB_ATTEMPTS (state, jobId) {
			const idx = state.exportJobs.findIndex(job => job.jobId === jobId);
			if (idx >= 0) {
				const job = state.exportJobs[idx];
				Vue.set(state.exportJobs, idx, { ...job, attempts: (job.attempts || 0) + 1 });
			}
		},
		REMOVE_EXPORT_JOB (state, jobId) {
			state.exportJobs = state.exportJobs.filter(job => job.jobId !== jobId);
			if (state.exportJobTimers[jobId]) {
				clearTimeout(state.exportJobTimers[jobId]);
				Vue.delete(state.exportJobTimers, jobId);
			}
		},
		SET_EXPORT_JOB_TIMER (state, { jobId, timer }) {
			if (state.exportJobTimers[jobId]) {
				clearTimeout(state.exportJobTimers[jobId]);
			}
			if (timer) {
				Vue.set(state.exportJobTimers, jobId, timer);
			} else if (state.exportJobTimers[jobId]) {
				clearTimeout(state.exportJobTimers[jobId]);
				Vue.delete(state.exportJobTimers, jobId);
			}
		},
		setIsResponseError (state, payload) {
			state.isResponseError = payload
		},
		[types.SET_PREFECTURES] (state, payload) {
			state.prefectures = payload
		},
		[types.SET_CHART] (state, payload) {
			state.dataChart = payload
		},
		[types.START_LOADING] (state) {
			state.loadingOverlay = true
			const loader = document.getElementById('loading')
			if (loader) {
				loader.style.display = 'flex'
			}
		},
		[types.END_LOADING] (state) {
			state.loadingOverlay = false
			const loader = document.getElementById('loading')
			if (loader) {
				loader.style.display = 'none'
			}
		},
		[types.SET_LAYOUT] (state, { layout }) {
			state.layout = layout
		},
		[types.SET_PROFILE] (state, { profile }) {
			state.profile = profile
			const unreadNotification = profile.data.unreadNotifications || 0
			state.unreadNotification = unreadNotification
			localStorage.setItem('email', profile.data.user.email)
		},
		[types.SET_TOKEN] (state, data) {
			state.token = data.token
			localStorage.setItem('token', data.token)
			localStorage.setItem('refresh-token', data.refreshToken)
		},
		[types.SET_USER_ID] (state, userId) {
			state.userId = userId
			localStorage.setItem('userId', userId)
		},
		[types.SET_PERMISSION] (state, permissions) {
			state.currentPermissions = permissions
		},
		[types.LOG_OUT] (state) {
			state.token = null
			state.profile = null
			localStorage.removeItem('token')
			localStorage.removeItem('userId')
			localStorage.removeItem('refresh-token')
			localStorage.removeItem('fcm_token')
			state.workflowRuntime = {
				userId: null,
				workflows: [],
				loaded: false,
				loading: false,
				error: null
			}
		},
		setMapInit (state, payload) {
			state.mapInit = payload
		},
		[types.SET_APP_UPDATE_TIME] (state, data) {
			state.previewUpdateTime = data.preview
			state.productionUpdateTime = data.production
		},
		[types.SET_UNREAD_NOTIFICATION] (state, number) {
			state.unreadNotification = number
		},
		[types.INCREMENT_UNREAD_NOTIFICATION] (state, delta) {
			state.unreadNotification = (state.unreadNotification || 0) + (Number(delta) || 0)
		},
		[types.SET_PROVINCE] (state, data) {
			state.provinces = data
		},
		[types.SET_DICTIONARIES] (state, data) {
			state.dictionaries = data
		},
		[types.SET_APPRAISE_OTHER] (state, data) {
			state.appraiseOther = data
		},
		[types.SET_APARTMENT] (state, data) {
			state.apartments = data
		},
		[types.SET_MAP_LOCATION] (state, mapLocation) {
			state.mapLocation = mapLocation
		},
		[types.SET_MAP_FILTER] (state, mapFilter) {
			state.mapFilter = mapFilter
		},
		[types.SET_NAV_EXP] (state, data) {
			state.navExp = data
		},
		SET_WORKFLOW_RUNTIME_LOADING (state, { userId, loading }) {
			state.workflowRuntime = {
				...state.workflowRuntime,
				userId,
				loading,
				error: loading ? null : state.workflowRuntime.error
			}
		},
		SET_WORKFLOW_RUNTIME_DATA (state, { userId, workflows }) {
			state.workflowRuntime = {
				userId,
				workflows,
				loaded: true,
				loading: false,
				error: null
			}
		},
		SET_WORKFLOW_RUNTIME_ERROR (state, { userId, error }) {
			state.workflowRuntime = {
				...state.workflowRuntime,
				userId,
				loading: false,
				error
			}
		},
		CLEAR_WORKFLOW_RUNTIME (state) {
			state.workflowRuntime = {
				userId: null,
				workflows: [],
				loaded: false,
				loading: false,
				error: null
			}
		},
		SET_REVIEW_LIST (state, reviews) {
			state.review.myReviews = reviews;
		},
		SET_REVIEW_CURRENT (state, review) {
			state.review.currentReview = review;
		},
		SET_REVIEW_LOADING (state, loading) {
			state.review.loading = loading;
		},
		SET_REVIEW_ERROR (state, error) {
			state.review.error = error;
		},
		SET_REVIEW_META (state, meta) {
			state.review.reviewMeta = meta;
		},
		RESET_REVIEW (state) {
			state.review.myReviews = [];
			state.review.currentReview = null;
			state.review.reviewMeta = null;
			state.review.error = null;
		},
	},
	actions: {
		async fetchWorkflowRuntime ({ state, commit }, { userId, force = false } = {}) {
			if (!userId) {
				commit('CLEAR_WORKFLOW_RUNTIME');
				return [];
			}

			if (
				!force &&
				state.workflowRuntime.loaded &&
				state.workflowRuntime.userId === userId
			) {
				return state.workflowRuntime.workflows;
			}

			if (
				!force &&
				workflowRuntimeRequest &&
				workflowRuntimeRequestUserId === userId
			) {
				return workflowRuntimeRequest;
			}

			commit('SET_WORKFLOW_RUNTIME_LOADING', { userId, loading: true });
			workflowRuntimeRequestUserId = userId;
			workflowRuntimeRequest = axios.get(`/api/workflows/get-workflow-follow-user/${userId}`)
				.then((res) => {
					const workflows = res && res.data && res.data.data && Array.isArray(res.data.data.workflows)
						? res.data.data.workflows
						: [];
					commit('SET_WORKFLOW_RUNTIME_DATA', { userId, workflows });
					return workflows;
				})
				.catch((error) => {
					commit('SET_WORKFLOW_RUNTIME_ERROR', { userId, error });
					throw error;
				})
				.finally(() => {
					workflowRuntimeRequest = null;
					workflowRuntimeRequestUserId = null;
				});

			return workflowRuntimeRequest;
		},
		refreshWorkflowRuntime ({ dispatch }, { userId } = {}) {
			return dispatch('fetchWorkflowRuntime', { userId, force: true });
		},
		enqueueExportJob ({ commit, dispatch }, job) {
			const nowIso = new Date().toISOString();
			const payload = {
				jobId: job.jobId,
				fileName: job.fileName,
				status: job.status || 'queued',
				message: job.message || 'Đã gửi yêu cầu xuất dữ liệu',
				downloadUrl: job.downloadUrl || null,
				progress: job.progress || 0,
				error: null,
				errorMessage: null,
				requestedAt: job.requestedAt || nowIso,
				startedAt: job.startedAt || null,
				finishedAt: job.finishedAt || null,
				exportType: job.exportType || 'data',
				workflowTemplateId: job.workflowTemplateId || null,
				statusUrl: job.statusUrl || null,
				autoDownload: job.autoDownload !== false,
				autoDownloaded: false,
				autoDownloadReady: false,
				attempts: 0,
			};
			commit('ADD_EXPORT_JOB', payload);
			dispatch('scheduleExportJobPoll', { jobId: payload.jobId, delay: EXPORT_POLL_INITIAL_DELAY });
		},
		async pollExportJobStatus ({ state, commit, dispatch }, { jobId }) {
			const job = state.exportJobs.find(item => item.jobId === jobId);
			if (!job) {
				dispatch('clearExportJobTimer', { jobId });
				return;
			}
			try {
				const response = await axios.get(`/api/task/export-status/${jobId}`);
				const raw = response && response.data ? response.data : {};
				const payload = raw && typeof raw === 'object' && raw.hasOwnProperty('data') ? raw.data || {} : raw || {};

				const status = typeof payload.status === 'string' ? payload.status : job.status;
				const progress = typeof payload.progress === 'number' ? payload.progress : job.progress;
				const downloadUrl = payload.download_url || payload.downloadUrl || job.downloadUrl || null;
				const finishedAt = payload.finished_at || payload.finishedAt || ((status === 'completed' || status === 'failed') ? new Date().toISOString() : job.finishedAt);
				const message = payload.message || raw.message || job.message;
				const error = payload.error || payload.error_detail || payload.errorDetail || null;

				commit('UPDATE_EXPORT_JOB', {
					jobId,
					patch: {
						status,
						progress,
						message,
						downloadUrl,
						error,
						errorMessage: error,
						startedAt: payload.started_at || payload.startedAt || job.startedAt || (status === 'processing' ? new Date().toISOString() : job.startedAt),
						finishedAt,
						lastCheckedAt: new Date().toISOString(),
						autoDownloadReady: job.autoDownload && status === 'completed' && !job.autoDownloaded,
					},
				});

				if (status === 'completed' || status === 'failed') {
					dispatch('clearExportJobTimer', { jobId });
					return;
				}

				commit('INCREMENT_EXPORT_JOB_ATTEMPTS', jobId);
				dispatch('scheduleExportJobPoll', { jobId });
			} catch (error) {
				commit('INCREMENT_EXPORT_JOB_ATTEMPTS', jobId);
				commit('UPDATE_EXPORT_JOB', {
					jobId,
					patch: {
						lastCheckedAt: new Date().toISOString(),
						message: 'Không thể cập nhật tiến trình, sẽ thử lại...',
					},
				});
				dispatch('scheduleExportJobPoll', { jobId, hasError: true });
			}
		},
		scheduleExportJobPoll ({ state, commit, dispatch }, { jobId, delay = null, hasError = false }) {
			const job = state.exportJobs.find(item => item.jobId === jobId);
			if (!job) {
				dispatch('clearExportJobTimer', { jobId });
				return;
			}
			const attempts = job.attempts || 0;
			const computedDelay = delay !== null
				? delay
				: Math.min(EXPORT_POLL_BASE_INTERVAL + attempts * 1500 + (hasError ? 2000 : 0), EXPORT_POLL_MAX_INTERVAL);

			const timer = setTimeout(() => {
				dispatch('pollExportJobStatus', { jobId });
			}, computedDelay);

			commit('SET_EXPORT_JOB_TIMER', { jobId, timer });
		},
		clearExportJobTimer ({ commit }, { jobId }) {
			commit('SET_EXPORT_JOB_TIMER', { jobId, timer: null });
		},
		markExportJobDownloaded ({ commit }, jobId) {
			commit('UPDATE_EXPORT_JOB', { jobId, patch: { autoDownloaded: true, autoDownloadReady: false } });
		},
		removeExportJob ({ commit }, jobId) {
			commit('REMOVE_EXPORT_JOB', jobId);
		},
		resetExportJobs ({ state, commit }) {
			state.exportJobs.forEach(job => {
				commit('SET_EXPORT_JOB_TIMER', { jobId: job.jobId, timer: null });
			});
			state.exportJobs = [];
			state.exportJobTimers = {};
		},
		async fetchMyReviews ({ commit }, query = {}) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.listMyReviews(query);
				const unwrapped = unwrapApiData(resp, 'Lỗi tải danh sách yêu cầu ký');
				const list = unwrapped && unwrapped.data !== undefined ? unwrapped.data : (unwrapped || []);
				const meta = unwrapped && unwrapped.meta !== undefined ? unwrapped.meta : null;
				commit('SET_REVIEW_LIST', list);
				commit('SET_REVIEW_META', meta);
				return list;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi tải danh sách yêu cầu ký');
				return [];
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
		async fetchReview ({ commit }, reviewId) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.getReview(reviewId);
				const review = unwrapApiData(resp, 'Lỗi tải yêu cầu ký');
				commit('SET_REVIEW_CURRENT', review);
				return review;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi tải yêu cầu ký');
				return null;
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
		async acceptReview ({ commit }, { reviewId, consent }) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.acceptReview(reviewId, consent);
				const review = unwrapApiData(resp, 'Lỗi xác nhận ký');
				commit('SET_REVIEW_CURRENT', review);
				return review;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi xác nhận ký');
				throw err;
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
		async rejectReview ({ commit }, { reviewId, reason }) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.rejectReview(reviewId, { reason });
				const review = unwrapApiData(resp, 'Lỗi từ chối ký');
				commit('SET_REVIEW_CURRENT', review);
				return review;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi từ chối ký');
				throw err;
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
		async cancelReview ({ commit }, reviewId) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.cancelReview(reviewId);
				const review = unwrapApiData(resp, 'Lỗi hủy yêu cầu ký');
				commit('SET_REVIEW_CURRENT', review);
				return review;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi hủy yêu cầu ký');
				throw err;
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
		async retryReviewSession ({ commit }, reviewId) {
			commit('SET_REVIEW_LOADING', true);
			commit('SET_REVIEW_ERROR', null);
			try {
				const { default: DigitalSignature } = await import('@/models/DigitalSignature');
				const resp = await DigitalSignature.retryReviewSession(reviewId);
				const review = unwrapApiData(resp, 'Lỗi gửi lại phiên ký');
				commit('SET_REVIEW_CURRENT', review);
				return review;
			} catch (err) {
				commit('SET_REVIEW_ERROR', err?.message || 'Lỗi gửi lại phiên ký');
				throw err;
			} finally {
				commit('SET_REVIEW_LOADING', false);
			}
		},
	}
})
